<img *ngIf="mostrarImg" [src]="rutaImagen" height="35" width="35" alt=""><label for={{id}} [class]="claseLabel">{{label}}</label>
<ng-select
  [items]="exampleData"
  bindLabel="text"
  bindValue="id"
  [id]="id"
  class="form-control"
  [ngClass]="{'is-invalid': control.invalid && control.dirty, 'is-valid': control.valid && control.dirty}"
  [disabled]="habilitar"
  [appendTo]="'body'"
  [dropdownPosition]="'auto'"
  [(ngModel)]="value"
  (ngModelChange)="modelChanged($event)">
</ng-select>
